import { FC, useMemo, } from "react";
// 方法
import { IEnumItem, useLayoutContext } from '../PageLayout/context/LayoutContext';
import { renderEnumName } from '../utils/renderUtils';
import { getClassName } from "./util";
// 常量
import { TABLE_COLUMN_EMPTY } from "../constants/constant";
import { DataStatusProps } from "./interface";
import './style.less';

/** 数据状态 */
const DataStatus: FC<DataStatusProps> = props => {
  const {
    value, enumCode, options, valueType,
    defaultStatus, successStatus, errorStatus, processingStatus, warningStatus, addStatus,
  } = props;
  const { enumData } = useLayoutContext();
  const renderValue = useMemo(() => {
    if (!value) return TABLE_COLUMN_EMPTY;
    let newOptions: IEnumItem[] = options || [];
    if (enumCode && enumData && enumData[enumCode]) {
      newOptions = enumData[enumCode].items || [];
    }
    return renderEnumName(value, newOptions);
  }, [enumCode, options, value]);
  const classes = useMemo(() => {
    if (!value) return '';
    if (valueType) {
      return getClassName(valueType);
    }
    if (Array.isArray(defaultStatus) && defaultStatus.includes(value)) {
      return getClassName('default');
    }
    if (Array.isArray(successStatus) && successStatus.includes(value)) {
      return getClassName('success');
    }
    if (Array.isArray(errorStatus) && errorStatus.includes(value)) {
      return getClassName('error');
    }
    if (Array.isArray(processingStatus) && processingStatus.includes(value)) {
      return getClassName('processing');
    }
    if (Array.isArray(warningStatus) && warningStatus.includes(value)) {
      return getClassName('warning');
    }
    if (Array.isArray(addStatus) && addStatus.includes(value)) {
      return getClassName('add');
    }
    return getClassName('default');
  }, [value, valueType, ]);
  return (
    <div
      className={classes}
    >{renderValue}</div>
  );
};

export default DataStatus;
